import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import Link from '../../Link/Link';
import clsx from 'clsx';
import useStyles from './LinkContainer.styles';
const LinkContainer = (props) => {
    const { links, isButton, buttonVariant = 'tertiary', classNames, maxLinks, triggerLinkAnalytics, linkClassNames, } = props;
    const { classes } = useStyles();
    return (_jsx(Box, { className: clsx(classes === null || classes === void 0 ? void 0 : classes.linkContainer, ...(classNames || []), maxLinks && maxLinks > 1 && classes.adjustLinkContainer), "data-testid": "link-container", children: links === null || links === void 0 ? void 0 : links.map((link, index) => {
            var _a;
            return (link === null || link === void 0 ? void 0 : link.label) ? (_jsx(Link, Object.assign({ button: isButton, thin: true, className: clsx(classes.link, !isButton && classes.linkText, ...(linkClassNames || [])) }, link, { variant: buttonVariant, triggerLinkAnalytics: triggerLinkAnalytics }), (_a = link.id) !== null && _a !== void 0 ? _a : `link-${index}`)) : null;
        }) }));
};
export default LinkContainer;
